import { render, staticRenderFns } from "./select-service-plan.vue?vue&type=template&id=5ed0c9f8"
import script from "./select-service-plan.vue?vue&type=script&lang=js"
export * from "./select-service-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports